module.exports = __webpack_public_path__ + "static/background-cases-123c849a7de901c774569aa7158c2255.png";